import { render, staticRenderFns } from "./EntityPage.vue?vue&type=template&id=3fd4987e&%3Akey=componentKey"
import script from "./EntityPage.vue?vue&type=script&lang=js"
export * from "./EntityPage.vue?vue&type=script&lang=js"
import style0 from "./EntityPage.vue?vue&type=style&index=0&id=3fd4987e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports